// extracted by mini-css-extract-plugin
export default {"title":"_998c9eb626","inner_title":"_2f1d580cb9","charge_btn":"_04d5d8abbd"};